import { useMemo } from 'react';

import { useGetCommonStore } from '@/store';

const AUTHBANNER_HEIGHT = 400;

const MOB_REGBANNER_WITH_OATH_HEIGHT = 1020;
const DESK_REGBANNER_WITH_OATH_HEIGHT = 650;

export const useSliderHeight = () => {
  const useCommonStore = useGetCommonStore();
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const height = useMemo(() => {
    if (isAuthenticated) {
      return AUTHBANNER_HEIGHT;
    }

    return isMobileDevice
      ? MOB_REGBANNER_WITH_OATH_HEIGHT
      : DESK_REGBANNER_WITH_OATH_HEIGHT;
  }, [isAuthenticated, isMobileDevice]);

  return height;
};
